import { EventBusService } from '@library-shared/services/event-bus/event-bus.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseService } from '@library-shared/base/base.service';
import { environment } from '@env/environment';
import { ApiRecordReturn } from '@library-shared/models/api-record-return';
import { ApiReturn } from '@library-shared/models/api-return';
import { EventBusEventType } from '@library/event-bus-event-type';
import { APIVersions } from '@library-shared/models/APIVersions';
import { vSession } from '@models/Views/vSession';
import { spSession_Create } from '@models/StoredProcs/spSession_Create';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService extends BaseService {
    private apiURL = environment.apiURL + '/api/authentication'; // URL to web api

    Session_Start(): Observable<ApiRecordReturn<spSession_Create>> {
        const url = `${this.apiURL}/Session_Start`;
        return this.http
            .post<ApiRecordReturn<spSession_Create>>(url, {}, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    Session_End(): Observable<ApiReturn> {
        const url = `${this.apiURL}/Session_End`;
        return this.http.post<ApiReturn>(url, {}, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }

    Session_Refresh(): Observable<ApiReturn> {
        const url = `${this.apiURL}/Session_Refresh`;
        return this.http.post<ApiReturn>(url, {}, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }

    AuthenticatedSession(): Observable<ApiRecordReturn<vSession>> {
        const url = `${this.apiURL}/AuthenticatedSessionCurrent`;
        return this.http
            .get<ApiRecordReturn<vSession>>(url, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    getAPIVersions(): Observable<ApiRecordReturn<APIVersions>> {
        const url = `${this.apiURL}/versions`;

        return this.http
            .get<ApiRecordReturn<APIVersions>>(url, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }
}
